import { formatMoney } from '../components/utilities';

const $attributes = $('[data-product-attributes]');

const Variants = {
  $wrapperProduct: $('[data-box-produto]'),
  config: {
    // pega o elemento que corresponde ao primeiro atributo
    $attr1: '',
    attr1Name: '',
    // pega o elemento que corresponde ao segundo atributo
    $attr2: '',
    attr2Name: '',
    // pega o elemento que corresponde ao terceiro atributo
    $attr3: '',
    attr3Name: '',
    // quantos atributos o produto tem para seleção
    qtdAttributes: 0,
    hasAttribute1: false,
    hasAttribute2: false,
    hasAttribute3: false,
  },
  setConfigDefault: function () {
    var _this = this;

    var $attr1 = $attributes.find('[data-attribute="1"]:not(.hidden)');
    var $attr2 = $attributes.find('[data-attribute="2"]:not(.hidden)');
    var $attr3 = $attributes.find('[data-attribute="3"]:not(.hidden)');

    var itensAttr1 = '';
    var itensAttr2 = '';
    var itensAttr3 = '';

    if ($attr1.length > 0) {
      itensAttr1 = $attr1.data('items');
      itensAttr1 = itensAttr1.split(' // ');
    }

    if ($attr2.length > 0) {
      itensAttr2 = $attr2.data('items');
      itensAttr2 = itensAttr2.split(' // ');
    }

    if ($attr3.length > 0) {
      itensAttr3 = $attr3.data('items');
      itensAttr3 = itensAttr3.split(' // ');
    }

    $.extend(true, _this.config, {
      // pega o elemento que corresponde ao primeiro atributo
      $attr1: $attr1,
      attr1Name: $attr1.data('attribute-name'),
      itemsAttr1: itensAttr1,
      // pega o elemento que corresponde ao segundo atributo
      $attr2: $attr2,
      attr2Name: $attr2.data('attribute-name'),
      itemsAttr2: itensAttr2,
      // pega o elemento que corresponde ao terceiro atributo
      $attr3: $attr3,
      attr3Name: $attr3.data('attribute-name'),
      itemsAttr3: itensAttr3,
    });
  },
  setQtdAttributes: function () {
    // Seta quantos atributos o produto possuí para seleção

    var qtdAttributes = 0;

    var $input = $attributes.find('[data-quantidade-atributos]');

    var $attr1 = this.config.$attr1;
    var $attr2 = this.config.$attr2;
    var $attr3 = this.config.$attr3;

    // considerando que o tamanho é o primeiro atributo
    if ($attr1.length > 0) {
      qtdAttributes++;
      this.config.hasAttribute1 = true;
    }

    // considerando que a cor é o segundo atributo
    if ($attr2.length > 0) {
      qtdAttributes++;
      this.config.hasAttribute2 = true;
    }

    // considerando que o custom é o terceiro atributo
    if ($attr3.length > 0) {
      qtdAttributes++;
      this.config.hasAttribute3 = true;
    }

    this.config.qtdAttributes = qtdAttributes;
  },
  setDisponibility: function () {
    var _this = this;

    if (_this.config.qtdAttributes > 1) {
      // Para quando há o atributo 1 e o atributo 2
      if (_this.config.hasAttribute1 && _this.config.hasAttribute2) {
        // Itera todas os tamanhos para verificar a disponibilidade
        for (var i = 0; i < _this.config.itemsAttr1.length; i++) {
          var tamanho = _this.config.itemsAttr1[i];
          var $tamanho = _this.config.$attr1.find('[data-attribute-value="' + tamanho + '"]');
          var objFind = {};
          var tamanhoAvailable = false;
          objFind[_this.config.attr1Name] = tamanho;

          // Busca todas as variações que contém o tamanho
          var results = vnda.variants.find(objFind);

          // Percorre todas as variantes com o tamanho
          for (var ii = 0; ii < results.length; ii++) {
            // Verifica se alguma variação tem o tamanho
            if (results[ii].available) {
              tamanhoAvailable = true;
            }
          }

          $tamanho.data('available', tamanhoAvailable);
          $tamanho.attr('data-available', tamanhoAvailable);

          if (tamanhoAvailable) {
            $tamanho.removeClass('unavailable');
            $tamanho.addClass('available');
          } else {
            $tamanho.removeClass('available');
            $tamanho.addClass('unavailable');
          }
        }
      }
    }
  },
  toggleOptionsStyle: function (_$option) {
    /*
      Define se o estilo do atributo passado por parametro é input ou dropdown
    */
    var selecao = _$option.data('selecao');
    var styleType = _$option.data('selecao-style');
    var $optionList = _$option.find('[data-attribute-value]');
    var show = true;
    var showStatusList = [];

    // console.info('atributo', selecao, styleType);

    $optionList.each(function (index, el) {
      var value = $(el).data('attribute-value');

      // console.info(value, value.length);
      if (selecao != 'cor') {
        if (value.length > 4) {
          showStatusList[index] = true;
        } else {
          showStatusList[index] = false;
        }
      } else {
        if (value.indexOf('#') < 0) {
          showStatusList[index] = true;
        } else {
          showStatusList[index] = false;
        }
      }
    });

    if (showStatusList.indexOf(true) >= 0) {
      if (styleType == 'input') {
        show = false;
      } else if (styleType == 'dropdown') {
        show = true;
      }
    } else {
      if (styleType == 'input') {
        show = true;
      } else if (styleType == 'dropdown') {
        show = false;
      }
    }

    if (!show) {
      _$option.addClass('hidden');
    }
  },
  setAttributeValue: function (_value, _$attribute) {
    // console.info('setAttributeValue', _value, _$attribute);

    var attrName = _$attribute.data('attribute-name');
    var $input = _$attribute.find('input[data-attribute-name="' + attrName + '"]');

    $input.val(_value);
  },
  setAttributeValueSelected: function (_value, _$attribute) {
    // console.info('setAttributeValueSelected', _value, _$attribute);

    var $selected = _$attribute.find('[data-selected]');
    $selected.html(_value);
  },
  markFirstOption: function () {
    var _this = this;

    var $attr1 = this.config.$attr1;
    var $attr2 = this.config.$attr2;
    var $attr3 = this.config.$attr3;

    /* console.log($attr1.find('[data-attribute-value][data-available=true]').first());
    console.log($attr2.find('[data-attribute-value][data-available=true]').first());
    console.log($attr3.find('[data-attribute-value][data-available=true]').first()); */

    // atributo com dropdown
    if ($attr1.find('[data-attribute-value][data-available=true]').first().length > 0) {
      $attr1.find('[data-attribute-value][data-available=true]').first().trigger('click');
    } else {
      $attr1.find('[data-attribute-value]').first().trigger('click');
    }

    if ($attr2.find('[data-attribute-value][data-available=true]').first().length > 0) {
      $attr2.find('[data-attribute-value][data-available=true]').first().trigger('click');
    } else {
      $attr2.find('[data-attribute-value]').first().trigger('click');
    }

    if ($attr3.find('[data-attribute-value][data-available=true]').first().length > 0) {
      $attr3.find('[data-attribute-value][data-available=true]').first().trigger('click');
    } else {
      $attr3.find('[data-attribute-value]').first().trigger('click');
    }
  },
  checkFirstAttribute: function () {
    var attributes = Variants.config.itemsAttr1;
    for (var i = 0; i < attributes.length; i++) {
      var attribute = attributes[i];
      var attrSize = $('[data-attribute-value="' + attribute + '"]');
      var obj = {};

      obj[Variants.config.attr1Name] = String(attribute);
      var results = vnda.variants.find(obj);
      var available = results.some((el) => el.available);

      if (available) {
        attrSize.data('available', true);
        attrSize.attr('data-available', true);

        attrSize.removeClass('unavailable');
        attrSize.addClass('available');
      } else {
        attrSize.data('available', false);
        attrSize.attr('data-available', false);

        attrSize.removeClass('available');
        attrSize.addClass('unavailable');
      }
    }
  },
  getSkuAttributes: function () {
    var _this = this;
    var objFindVariant = {};
    var objVariant;

    //console.log(_this.config)

    if (_this.config.hasAttribute1) {
      var nameAttr1 = _this.config.attr1Name;
      var valueAttr1 = _this.config.$attr1
        .find('input[data-attribute-name="' + nameAttr1 + '"]')
        .val();
      objFindVariant[nameAttr1] = valueAttr1;
    }

    if (_this.config.hasAttribute2) {
      var nameAttr2 = _this.config.attr2Name;
      var valueAttr2 = _this.config.$attr2
        .find('input[data-attribute-name="' + nameAttr2 + '"]')
        .val();
      objFindVariant[nameAttr2] = valueAttr2;
    }

    if (_this.config.hasAttribute3) {
      var nameAttr3 = _this.config.attr3Name;
      var valueAttr3 = _this.config.$attr3
        .find('input[data-attribute-name="' + nameAttr3 + '"]')
        .val();
      objFindVariant[nameAttr3] = valueAttr3;
    }

    objVariant = vnda.variants.find(objFindVariant);

    //console.info('objFindVariant', objFindVariant);
    //console.info('objVariant', objVariant);

    return objVariant;
  },
  updatePrice: function (sku) {
    const wrapperPrice = document.querySelector('.wrapper-price');

    var elemPrice = document.querySelector('[data-section-product] [data-init-price]');
    var event = new Event('change');

    if (!elemPrice) return;
    wrapperPrice.classList.add('hidden-text');
    elemPrice.setAttribute('data-sku', sku);
    elemPrice.dispatchEvent(event);
  },

  // COMPORTAMENTO DE QUANDO O USUÁRIO SELECIONA UM ATRIBUTO
  setResultVariants: function () {
    var _this = this;
    // busca a variante
    var objVariant = _this.getSkuAttributes();

    // console.info('objVariant', objVariant);

    if (objVariant.length > 0) {
      // seta o sku da variante que o usuário selecionou
      _this.$wrapperProduct.find('input[name="sku"]').val(objVariant[0].sku);

      // atualiza o preço do produto conforme a variante selecionada
      _this.updatePrice(objVariant[0].sku);

      if ($('[data-form-notify]').length > 0) {
        $('[data-form-notify] input[name="sku"]').val(objVariant[0].sku);
      }

      // verifica se a variante selecionada está disponível ou não
      if (!objVariant[0].available) {
        _this.setProdutoIndisponivel(objVariant[0]);
      } else {
        _this.setProdutoDisponivel(objVariant[0]);
      }
    } else {
      _this.setProdutoIndisponivel(objVariant[0]);
    }

    if (objVariant.length > 0) {
      $attributes.find('[data-variant-selected]').html(objVariant[0].name);

      // PARA AS IMAGENS
      _this.setImagesProduct(objVariant[0].sku);
    }
  },
  setProdutoIndisponivel: function (_variant) {
    var _this = this;
    var $btnComprar = _this.$wrapperProduct.find('[data-action="add-cart"]');
    var textUnavailable = $btnComprar.data('text-unavailable');

    $btnComprar.data('available', 'false');
    $btnComprar.removeClass('available');
    $btnComprar.addClass('unavailable');
    $btnComprar.html(textUnavailable);


    var $btnComprarKit = _this.$wrapperProduct.find('[data-kit-button]');
    var textUnavailableKit = $btnComprarKit.data('text-unavailable');

    $btnComprarKit.data('available', 'false');
    $btnComprarKit.removeClass('available');
    $btnComprarKit.addClass('unavailable');
    $btnComprarKit.html(textUnavailableKit);

    // AVISE-ME QUANDO CHEGAR AQUI
    if (_variant) {
      _this.setFormNotify(_variant);
    }
  },
  setFormNotify: function (_variant) {
    var height = $('[data-form-notify]').find('.form-wrapper').outerHeight(true);

    $('[data-form-notify]').addClass('active').css('height', height);

    setTimeout(function () {
      $(document.body).trigger('sticky_kit:recalc');
    }, 500);

    if ($('[data-form-notify]').length > 0) {
      $('[data-form-notify] input[name="sku"]').val(_variant.sku);
    }
  },
  checkCombinations: function (_value, _attributeName) {
    var _this = this;
    var obj = {};
    obj[_attributeName] = String(_value);
    var results = vnda.variants.find(obj);

    //console.info('checkCombinations', _attributeName, _value);
    //console.info('results combinations', results);

    // Click no select customizado
    $(`.selectCustom-option[data-value="${_value}"]`).click();

    // Verifica a disponibilidade das cores quando um tamanho é selecionado
    if (_this.config.attr1Name == _attributeName) {
      var cores = _this.config.itemsAttr2;
      var thirdAttributeList = _this.config.itemsAttr3;
      var objFind = {};
      objFind[_attributeName] = String(_value);

      for (var i = 0; i < thirdAttributeList.length; i++) {
        objFind[_this.config.attr3Name] = String(thirdAttributeList[i]);
        var firstThirdResults = vnda.variants.find(objFind);

        var thirdAttribute = thirdAttributeList[i];
        var $thirdAttribute = $('[data-attribute-value="' + thirdAttribute + '"]');

        //console.info('1º e 3º results', firstThirdResults);

        if (firstThirdResults.length > 0) {
          var available = firstThirdResults.some((el) => el.available);

          $thirdAttribute.removeClass('disable');

          if (available) {
            $thirdAttribute.data('available', true);
            $thirdAttribute.attr('data-available', true);

            $thirdAttribute.removeClass('unavailable');
            $thirdAttribute.addClass('available');
          } else {
            $thirdAttribute.data('available', false);
            $thirdAttribute.attr('data-available', false);

            $thirdAttribute.removeClass('available');
            $thirdAttribute.addClass('unavailable');
          }
        } else {
          $thirdAttribute.addClass('disable');
        }
      }

      for (var i = 0; i < cores.length; i++) {
        objFind[_this.config.attr2Name] = String(cores[i]);
        var corTamanhoResults = vnda.variants.find(objFind);

        var cor = cores[i];
        var $cor = $('[data-attribute-value="' + cor + '"]');

        //console.info('corTamanhoResults', corTamanhoResults);

        if (corTamanhoResults.length > 0) {
          var available = corTamanhoResults.some((el) => el.available);

          $cor.removeClass('disable');

          if (available) {
            $cor.data('available', true);
            $cor.attr('data-available', true);

            $cor.removeClass('unavailable');
            $cor.addClass('available');
          } else {
            $cor.data('available', false);
            $cor.attr('data-available', false);

            $cor.removeClass('available');
            $cor.addClass('unavailable');
          }
        } else {
          $cor.addClass('disable');
        }
      }
    }

    // verifica a disponibilidade do terceiro atributo quando o segundo é selecionado
    else if (_this.config.attr2Name == _attributeName) {
      var thirdAttributeList = _this.config.itemsAttr3;
      var objFind = {};
     
      if (_this.config.itemsAttr1) {
        objFind[_this.config.attr1Name] = String(
          $(`[name="attribute-${_this.config.attr1Name}"]:checked`).val()
        );
      }

      objFind[_this.config.attr2Name] = String(_value);

      // console.log('objFind', objFind)

      for (var i = 0; i < thirdAttributeList.length; i++) {
        objFind[_this.config.attr3Name] = String(thirdAttributeList[i]);
        var firstThirdResults = vnda.variants.find(objFind);

        var thirdAttribute = thirdAttributeList[i];
        var $thirdAttribute = $('[data-attribute-value="' + thirdAttribute + '"]');

        //console.info('1º e 3º results', firstThirdResults);

        if (firstThirdResults.length > 0) {
          var available = firstThirdResults.some((el) => el.available);

          $thirdAttribute.removeClass('disable');

          if (available) {
            $thirdAttribute.data('available', true);
            $thirdAttribute.attr('data-available', true);

            $thirdAttribute.removeClass('unavailable');
            $thirdAttribute.addClass('available');
          } else {
            $thirdAttribute.data('available', false);
            $thirdAttribute.attr('data-available', false);

            $thirdAttribute.removeClass('available');
            $thirdAttribute.addClass('unavailable');
          }
        } else {
          $thirdAttribute.addClass('disable');
        }
      }
    }
  },

  setSelectOptions() {
    if (!Variants.config.$attr3) return;

    const $wrapperOption = $(`[data-attribute="3"][data-attribute-name="${Variants.config.attr3Name}"]`);
    const $options = $wrapperOption.find('.selectNative').find('[data-text]');

    $options.each(function() {
      const text = $(this).attr('data-text');
      
      if ($(this).hasClass('disable')) {
        $(`[data-value="${text}"]`).addClass('disable');
      } else {
        $(`[data-value="${text}"]`).removeClass('disable');
      }
    });
  },

  setProdutoDisponivel: function () {
    var _this = this;
    var $btnComprar = _this.$wrapperProduct.find('[data-action="add-cart"]');
    var textAvailable = $btnComprar.data('text-available');

    $btnComprar.data('available', 'true');
    $btnComprar.removeClass('unavailable');
    $btnComprar.addClass('available');
    $btnComprar.html(textAvailable);

    var $btnComprarKit = _this.$wrapperProduct.find('[data-kit-button]');
    var textAvailableKit = $btnComprarKit.data('text-available');

    $btnComprarKit.data('available', 'true');
    $btnComprarKit.removeClass('unavailable');
    $btnComprarKit.addClass('available');
    $btnComprarKit.html(textAvailableKit);

    $('[data-form-notify]').removeClass('active').css('height', 0);
  },
  /* 
    Exibe as imagens que contém o sku passado por parâmetro
  */
  setImagesProduct: function (_sku = '') {
    var $mainImages = $('[data-section-product]').find('[data-product-images] [data-main-slider]');
    var $thumbsImages = $('[data-section-product]').find('[data-product-images] [data-slider-thumbs]');
    var slideProduct = window.sliderProduct[0];
    var $imagesWithoutSkus = $mainImages.find('[data-skus-image=","]');
    var $thumbsWithoutSkus = $thumbsImages.find('[data-skus-image=","]');

    // console.info($mainImages.find('[data-skus-image*="' + _sku + ',"]'));
    // console.info('[data-skus-image*="' + _sku + '"]');

    // Esconde as imagens que não contém o sku
    $mainImages
      .find("[data-image][data-skus-image]")
      .removeClass("active")
      .addClass("inactive");

    $thumbsImages
      .find("[data-image-thumb][data-skus-image]")
      .removeClass("active")
      .addClass("inactive");

    // Mostra as imagens que contém o sku
    $mainImages
      .find('[data-image][data-skus-image*="' + _sku + ',"]')
      .addClass("active")
      .removeClass("inactive");

    $thumbsImages
      .find('[data-image-thumb][data-skus-image*="' + _sku + ',"]')
      .addClass("active")
      .removeClass("inactive");

    // As imagens sem skus selecionados são exibidas sempre
    $imagesWithoutSkus.removeClass("inactive").addClass("active");
    $thumbsWithoutSkus.removeClass("inactive").addClass("active");

    if ($thumbsImages.find('[data-image-thumb][data-skus-image*="' + _sku + ',"]').length > 0) {
      slideProduct.slideTo($('[data-image-thumb][data-skus-image*="' + _sku + ',"]').first().index('[data-image-thumb]:visible'));
    } else {
      slideProduct.slideTo($('[data-image-thumb].active').index('[data-image-thumb]:visible'));
    }
  },    
  
  execActionAttr: function (_attrName, _valueSelected) {
    var _this = this;

    if (_this.config.attr1Name == _attrName) {
      if (typeof attr1Action == 'function') {
        attr1Action(_valueSelected);
      }
    } else if (_this.config.attr2Name == _attrName) {
      if (typeof attr2Action == 'function') {
        attr2Action(_valueSelected);
      }
    } else if (_this.config.attr3Name == _attrName) {
      if (typeof attr3Action == 'function') {
        attr3Action(_valueSelected);
      }
    }
  },
  removeFirstOption: function () {
    const inputs = document.querySelectorAll('[data-product-attributes] .prod-option input[type="radio"]');
    if (inputs.length > 0) inputs.forEach(input => { input.checked = false });
  },
  init: function () {
    var _this = this;

    // DEFINE SE O QUE VAI APARECER É A OPÇÃO EM INPUT RADIO OU O DROPDOWN
    $attributes.find('[data-prod-option]').each(function (index, el) {
      // _this.toggleOptionsStyle($(el));
    });

    $attributes.on(
      'click',
      '[data-prod-option]:not(.hidden) [data-attribute-value]',
      function (event) {
        if ($(this).is('a')) {
          event.preventDefault();
        }

        var $wrapperAttribute = $(this).closest('[data-prod-option]');

        var selecao = $wrapperAttribute.data('selecao');
        var selecaoStyle = $wrapperAttribute.data('selecao-style');
        var attrName = $wrapperAttribute.data('attribute-name');
        var value = $(this).data('attribute-value');

        // console.info('selecao value', selecao, attrName, value);

        _this.setAttributeValue(value, $wrapperAttribute);
        _this.setAttributeValueSelected(value, $wrapperAttribute);

        _this.checkCombinations(value, attrName);
        _this.setSelectOptions(); 
        _this.execActionAttr(attrName, value);

        let inputSelected = document.querySelector('.input:checked');

        console.log();

        if (this.classList.contains("label") || inputSelected) {
          _this.setResultVariants();
        } else if(!(_this.config.hasAttribute1 && _this.config.hasAttribute2) && _this.config.hasAttribute3) {
          _this.setResultVariants();
        }

      }
    );

    if (_this.qtdAttributes == 0) {
      var variant = vnda.variants.all()[0];

      if (!variant.available) {
        _this.setProdutoIndisponivel(variant);
      } else {
        _this.setProdutoDisponivel(variant);
      }
    }

    _this.setConfigDefault();
    _this.setQtdAttributes();
    _this.setDisponibility();
    _this.checkFirstAttribute();
    _this.removeFirstOption();

    //console.log(_this.config)
  },
};

function attr1Action(_valueSelected) {
  var $attr1 = Variants.config.$attr1;
  var $attr2 = Variants.config.$attr2;
  var $attr3 = Variants.config.$attr3;

  //console.log($attr1.find('[data-attribute-value][data-available=true]').first());
  //console.log($attr2.find('[data-attribute-value][data-available=true]').first());
  //console.log($attr3.find('[data-attribute-value][data-available=true]').first());

  //console.log('attr1Action', $attr2)

  if ($attr2.find('[data-attribute-value][data-available=true]:not(.disable)').first().length > 0) {
    //console.log('THIS', $attr2.find('[data-attribute-value][data-available=true]:not(.disable)').first())
    $attr2
      .find('[data-attribute-value][data-available=true]:not(.disable)')
      .first()
      .trigger('click');
  } else if ($attr2.find('[data-attribute-value][data-available=true]').first().length > 0) {
    $attr2.find('[data-attribute-value][data-available=true]').first().trigger('click');
  } else {
    $attr2.find('[data-attribute-value]').first().trigger('click');
  }

  if ($attr2.length < 1) {
    if ($attr3.find('[data-attribute-value][data-available=true]:not(.disable)').first().length > 0) {
      //console.log('THIS', $attr3.find('[data-attribute-value][data-available=true]:not(.disable)').first())
      $attr3
        .find('[data-attribute-value][data-available=true]:not(.disable)')
        .first()
        .trigger('click');
    } else if ($attr3.find('[data-attribute-value][data-available=true]').first().length > 0) {
      $attr3.find('[data-attribute-value][data-available=true]').first().trigger('click');
    } else {
      $attr3.find('[data-attribute-value]').first().trigger('click');
    }
  }
}

function attr2Action(_valueSelected) {
  var $attr1 = Variants.config.$attr1;
  var $attr2 = Variants.config.$attr2;
  var $attr3 = Variants.config.$attr3;

  //console.log($attr1.find('[data-attribute-value][data-available=true]').first());
  //console.log($attr2.find('[data-attribute-value][data-available=true]').first());
  //console.log($attr3.find('[data-attribute-value][data-available=true]').first());

  if ($attr3.find('[data-attribute-value][data-available=true]:not(.disable)').first().length > 0) {
    //console.log('THIS', $attr3.find('[data-attribute-value][data-available=true]:not(.disable)').first())
    $attr3
      .find('[data-attribute-value][data-available=true]:not(.disable)')
      .first()
      .trigger('click');
  } else if ($attr3.find('[data-attribute-value][data-available=true]').first().length > 0) {
    $attr3.find('[data-attribute-value][data-available=true]').first().trigger('click');
  } else {
    $attr3.find('[data-attribute-value]').first().trigger('click');
  }
}

export default Variants;
